import * as React from 'react';
import { Row, Col } from 'reactstrap';
import { IFormValidation, IFormValidationEvent, ILicensureInstanceForm } from '../../../model/forms';
import { IInstanceFunctions } from '../InstancedSectionBase';
import { TextField, DateRangeField, RichTextEditorField } from '../../fields';

interface ILicensureInstanceProperties extends IInstanceFunctions<ILicensureInstanceForm> {
  instance: ILicensureInstanceForm;
  validation?: IFormValidation;
}

class LicensureInstance extends React.PureComponent<ILicensureInstanceProperties> {

  onValidate(instanceId: number, event: IFormValidationEvent) {
    if (this.props.onValidate !== undefined) {
      this.props.onValidate({
        ...event,
        name: `${event.name}$${instanceId}`
      });
    }
  }
    
  render() {
    return <React.Fragment>
      <Row>
        <Col xs={12}>
          <TextField label="License Name" id={`licensure_instance_${this.props.instance.instanceId}_name`} value={this.props.instance.name} onChange={this.props.onFieldChange} />
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={6}>
          <TextField label="License Number" id={`licensure_instance_${this.props.instance.instanceId}_id`} value={this.props.instance.id} onChange={this.props.onFieldChange} />
        </Col>
        <Col xs={12} lg={6}>
          <DateRangeField 
            id={`licensure_instance_${this.props.instance.instanceId}_enrollmentDates`}
            from={{
              name: `licensure_enrollmentDates_instance_${this.props.instance.instanceId}_validFrom`,
              value: this.props.instance.validFrom,
              placeholder: "Valid From",
              valid: !this.props.validation?.errors?.has(`validFrom$${this.props.instance.instanceId}`),
              message: this.props.validation?.errors?.get(`validFrom$${this.props.instance.instanceId}`)
            }}
            to={{
              name: `licensure_enrollmentDates_instance_${this.props.instance.instanceId}_validTo`,
              value: this.props.instance.validTo,
              placeholder: "Valid To",
              valid: !this.props.validation?.errors?.has(`validTo$${this.props.instance.instanceId}`),
              message: this.props.validation?.errors?.get(`validTo$${this.props.instance.instanceId}`)
            }}
            onChange={this.props.onFieldChange}
            onValidate={this.onValidate.bind(this, this.props.instance.instanceId)}
            format='FullDate' />
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={12}>
          <RichTextEditorField label="Description" id={`licensure_instance_${this.props.instance.instanceId}_description`} value={this.props.instance.description} onChange={this.props.onFieldChange} />
        </Col>
      </Row>
    </React.Fragment>
  }
}

export function IsEmpty(instance: ILicensureInstanceForm) {
  if (instance.name !== undefined && instance.name.length >= 0) {
    return false;
  }
  if (instance.validFrom !== undefined && instance.validFrom.length >= 0) {
    return false;
  }
  if (instance.validTo !== undefined && instance.validTo.length >= 0) {
    return false;
  }
  if (instance.description !== undefined && instance.description.length >= 0) {
    return false;
  }

  return true;
}

export default LicensureInstance;